import styled, { css } from 'styled-components'

import { Button, ButtonProps } from '@/components/shared-components/BUI/Button'

export type BaseButtonProps = ButtonProps & {
  hasValue: boolean
}

// TODO: FIX THIS BUILD ISSUE PROPERLY
export const BaseButton: any = styled(Button).attrs({
  variant: 'secondary' as ButtonProps['variant'],
})<BaseButtonProps>`
  color: ${({ theme }) => theme.colour.secondary._400};
  border-color: ${({ theme }) => theme.colour.secondary._400};

  ${({ theme, hasValue }) =>
    hasValue &&
    css`
      border: 0;
      color: ${theme.colour.secondary._800};
      background-color: ${theme.colour.neutral.surface};
    `}
`
